import { NAME_TOOLTIP_TEXT, withFieldGroup } from '@massilia/features'
import { Users } from 'lucide-react'

import type { ReservationSchema } from '@/lib/schemas/reservation/reservation.schema'

import { ImportantNotice } from '@/components/ui/important-notice'

import { FidelityCardsFormGroup } from '../-components/fidelity-card-fields'
import { IdentityDocumentsFormGroup } from '../-components/identity-document-fields'
import { PassengerCard } from '../-components/passenger-card'
import { SectionWrapper } from '../-components/section-wrapper'

export const PassengersFormGroup = withFieldGroup({
  defaultValues: {} as Pick<ReservationSchema, 'passengers'>,
  render: function Passengers({ group }) {
    return (
      <group.Subscribe selector={(state) => state.values.passengers}>
        {(passengers) => {
          if (!passengers || passengers.length === 0) {
            return (
              <SectionWrapper
                description="Informations sur les passagers de votre voyage"
                icon={Users}
                title="Voyageurs"
              >
                <div className="flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-stone-200 bg-stone-50/50 py-12 text-center">
                  <Users className="mb-3 h-10 w-10 text-stone-300" />
                  <p className="text-sm text-stone-500">Aucun passager trouve pour ce devis</p>
                </div>
              </SectionWrapper>
            )
          }

          return (
            <SectionWrapper
              description="Verifiez les informations et completez les documents d'identite"
              icon={Users}
              title="Voyageurs"
            >
              <div className="space-y-4">
                <ImportantNotice title="Documents d'identite" variant="info">
                  Les numeros de CNI/Passeport et cartes de fidelite sont optionnels. Vous pourrez
                  les communiquer ulterieurement si necessaire.
                </ImportantNotice>

                <div className="grid gap-4 lg:grid-cols-2">
                  {passengers.map((passenger, index) => (
                    <PassengerCard
                      key={passenger.passengerId}
                      editFields={
                        <div className="space-y-2">
                          <div className="grid grid-cols-2 gap-2">
                            <group.AppField
                              name={`passengers[${index}].firstName`}
                              children={(field) => (
                                <field.TextField
                                  label="Prénom"
                                  placeholder="Jean"
                                  questionToolTip={NAME_TOOLTIP_TEXT}
                                />
                              )}
                            />
                            <group.AppField
                              name={`passengers[${index}].lastName`}
                              children={(field) => (
                                <field.TextField
                                  label="Nom"
                                  placeholder="Dupont"
                                  questionToolTip={NAME_TOOLTIP_TEXT}
                                />
                              )}
                            />
                          </div>
                          <group.AppField
                            name={`passengers[${index}].birthDate`}
                            children={(field) => <field.DateField label="Date de naissance" />}
                          />
                        </div>
                      }
                      index={index}
                      passenger={passenger}
                    >
                      <div className="space-y-4">
                        <IdentityDocumentsFormGroup
                          fields={{
                            identityDocuments: `passengers[${index}].identityDocuments`,
                          }}
                          form={group}
                        />

                        <div className="border-t border-dashed border-stone-200" />

                        <FidelityCardsFormGroup
                          fields={{
                            fidelityCards: `passengers[${index}].fidelityCards`,
                          }}
                          form={group}
                        />
                      </div>
                    </PassengerCard>
                  ))}
                </div>
              </div>
            </SectionWrapper>
          )
        }}
      </group.Subscribe>
    )
  },
})
